import PropTypes from 'prop-types';

import { CompanyCodesPropTypes } from '../../shared/propTypes/companyCodes';
import { BusinessUnitsPropTypes } from '../../shared/propTypes/businessUnits';
import { LegalEntitiesPropTypes } from '../../shared/propTypes/legalEntities';
import { BookToTaxDifferencesPropTypes } from '../../shared/propTypes/bookToTaxDifferences';
import { TaxRatesPropTypes } from '../../shared/propTypes/taxRates';
import { TaxBookingEntitiesPropTypes } from '../../shared/propTypes/taxBookingEntities';
import { TaxAccountingsPropTypes } from '../../shared/propTypes/taxAccounting';
import { UsersPropTypes } from '../../shared/propTypes/users';
import { GlJournalsPropTypes as SubledgerMapsPropTypes } from '../../shared/propTypes/glJournals';
import { CurrenciesPropTypes } from '../../shared/propTypes/currency';
import { CurrencyConversionRatesPropTypes } from '../../shared/propTypes/currencyConversionRate';

import { PillTypes, Resources } from './constants';

export const ConfigurationSettingsPropTypes = PropTypes.shape({
  [Resources[PillTypes.COMPANY_CODES]]: CompanyCodesPropTypes,
  [Resources[PillTypes.BUSINESS_UNITS]]: BusinessUnitsPropTypes,
  [Resources[PillTypes.LEGAL_ENTITIES]]: LegalEntitiesPropTypes,
  [Resources[PillTypes.BOOK_TO_TAX_DIFFERENCES]]: BookToTaxDifferencesPropTypes,
  [Resources[PillTypes.TAX_RATES]]: TaxRatesPropTypes,
  [Resources[PillTypes.TAX_BOOKING_ENTITIES]]: TaxBookingEntitiesPropTypes,
  [Resources[PillTypes.TAX_ACCOUNTING]]: TaxAccountingsPropTypes,
  [Resources[PillTypes.USERS]]: UsersPropTypes,
  [Resources[PillTypes.SUBLEDGER_MAP]]: SubledgerMapsPropTypes.isRequired,
  [Resources[PillTypes.CURRENCY]]: CurrenciesPropTypes.isRequired,
  [Resources[PillTypes.CURRENCY_CONVERSION_RATES]]: CurrencyConversionRatesPropTypes.isRequired,
});
